module.exports = __webpack_public_path__ + "img/product-smoke-33.a6e721ee.jpg";